import React from 'react';
import { Field } from 'react-final-form';
import { TextField } from '@material-ui/core';
import MenuItem from '@mui/material/MenuItem';

const MUITextField = ({
    name, menu, value, ...restProps
}) => (
    <Field name={name}>
        {({ input, meta }) => (
            <TextField
                {...restProps}
                {...input}
                fullWidth
                value={value}
                menu={menu}
                error={meta.error && meta.touched}
                helperText={meta.touched && meta.error}
            >

                {menu && menu.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
        )}
    </Field>
);

export default MUITextField;

